import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [{
  path: '/was/:itcsno/:ci',
  name: 'main',
},
{
  path: '/intro',
  name: 'intro',
  component: () =>
    import(/* webpackChunkName: "mccUser" */ '../views/agree/intro'),
},
{
  path: '/home',
  name: 'home',
  component: () =>
    import(/* webpackChunkName: "mccUser" */ '../views/home/main'),
},
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
